"use client";

import { useEffect } from "react";
import layup from "layup-js";
import "layup-js/style.css";
import { useCurrentUser } from "@knowt/syncing/hooks/user/useCurrentUser";
import { LAYUP_GUIDANCE_ENDPOINT } from "@/config/deployConstants";
import { AccountType, SubscriptionType } from "@knowt/syncing/graphql/schema";

const SyncLayupData = () => {
    const { user, userId, isLoading } = useCurrentUser({ waitForFallbackData: true, from: "SyncPointerData" });

    useEffect(() => {
        if (!userId || !user || isLoading) return;

        const loadLayup = async () => {
            const theme = document.documentElement.getAttribute("data-theme");
            try {
                layup.init(process.env.NEXT_PUBLIC_LAYUP_API_KEY ?? "", {
                    group_id: "everyone",
                    platform_user_data: {
                        email: user.Email,
                        first_name: user.Name ?? "",
                        user_id: user.ID ?? "",
                        username: user.username ?? "",
                        plan_identifier: (user?.subscriptionType ?? SubscriptionType.BASIC).toLowerCase(),
                        role_identifier: user?.accountType === AccountType.Student ? "student" : "teacher",
                    },
                    guidance_endpoint: LAYUP_GUIDANCE_ENDPOINT,
                    theme: { mode: theme === "dark" ? "dark" : "light" },
                    show_widget: false,
                });
            } catch (error) {
                // biome-ignore lint: use console.error
                console.error("Failed to initialize Layup:", error);
            }
        };
        loadLayup();
    }, [userId, isLoading]);

    return null;
};

export default SyncLayupData;
